import { isUndefined } from "lodash";
import { UsedHold } from "../../assets/hangboards/classes/Hangboard";

export interface IBlocGroup{
    blocs: [IBloc];
    multiplier: number;
    id:number;
    index:number;
    updateState(blocGroup: IBlocGroup): void;
    deleteBloc(id:number): void;
    deleteSelf(id: number):void;
    setIndex(index:number):void;
    setMultiplier(param: "+"|"-");
    addBloc(type:"hang"|"rest", bloc?:IBloc);
    setRestTime(blocId:number, param:string): void;
    displayRestTime(blocId: number);
}
export interface IBloc{
    time:number;
    id: number;
    blocGroupId: number;
    guideline: string;
    setTime(x): void;
    updateBloc(bloc: IBloc): void;
}
export interface ITrainingBloc extends IBloc{
    intensity: number;
    fingers: [[number], [number]];
    usedHolds:[];
    setUsedHolds(usedHolds: UsedHold[]);
    setIntensity(param: "+"|"-"):void;
    setFingers(handIndex:number, findIndex:number):void;
    setGuideline(e:any, data: {value: string}):void;
}

export interface IRestBloc extends IBloc{}

export class BlocGroupClass implements IBlocGroup{
    public blocs; multiplier; id; updateState; deleteSelf; index;
    constructor(props){
        this.id = props.id;
        this.multiplier = !isUndefined(props.multiplier) ? props.multiplier : 1;
        this.blocs = [];
        this.index=1;
        this.updateState = props.updateState;
        this.deleteSelf= props.delete;
        if(props.blocs)
            this.generateBlocs(props.blocs)
    }
    public setIndex = (index)=>{
        this.index = index+1;
    }
    public generateBlocs(newBlocs:[IBloc]){
        this.blocs=[];
        return newBlocs.map((bloc:IBloc)=>{
            if((bloc as any).intensity)
                this.addBloc('hang',bloc);
            else
                this.addBloc('rest',bloc);
        });  
    }

    public setMultiplier=(param: string)=>{
        if(param == '+')
            this.multiplier +=1;
        else if(param == '-' && this.multiplier >1)
            this.multiplier-=1;
        this.updateState(this);
    }

    public updateBloc= (newBloc: IBloc)=>{
        const blocIndex = this.blocs.findIndex(bloc=> bloc.id == newBloc.id);
        this.blocs[blocIndex] = newBloc;
        this.updateState(this);
    }

    public deleteBloc = (id:number) => {
        if (this.blocs.length/2 === 1) {
            throw "BlocGroup must have at least one bloc"; // TODO : display error message
        } else {
            const blocIndex = this.blocs.findIndex(bloc => bloc.id == id);
            this.blocs[blocIndex] instanceof TrainingBlocClass ? this.blocs.splice(blocIndex, 2) : this.blocs.splice(blocIndex, 1);
            this.updateState(this);    
        }
    }

    public addBloc= (type, bloc?)=>{
        let newBloc: IBloc;
        const blocIndex = this.blocs.length!=0 ? this.blocs.length-1 : 0
        const lastBlocId = this.blocs.length!=0 ?this.blocs[blocIndex].id : 0;
        if (type== "hang"){
            if(bloc)
                newBloc = new TrainingBlocClass({ id: lastBlocId + 1,blocGroupId: this.id, handleDelete: this.deleteBloc, 
                    handleUpdate: this.updateBloc, bloc:bloc});
            else
                newBloc = new TrainingBlocClass({ id: lastBlocId + 1,blocGroupId: this.id, handleDelete: this.deleteBloc, 
                    handleUpdate: this.updateBloc, guideline: 'guideline.hang',});
        }
            
        else{
            if(bloc)
                newBloc = new RestBlocClass({ id: lastBlocId + 1, blocGroupId: this.id,handleDelete: this.deleteBloc, handleUpdate: this.updateBloc, bloc:bloc });
            else
                newBloc = new RestBlocClass({ id: lastBlocId + 1, blocGroupId: this.id,handleDelete: this.deleteBloc, handleUpdate: this.updateBloc, guideline:'guideline.rest'});
        }
            
        this.blocs.push(newBloc);
        if(!bloc) this.updateState(this);
    }

    public setRestTime = (blocId: number, param: string) => {
        const restBlocIndex = this.blocs.findIndex(bloc => bloc.id == blocId) + 1;
        if (param == '+')
            this.blocs[restBlocIndex].time++;
        else if (param == '-' && this.blocs[restBlocIndex].time > 0) {
            this.blocs[restBlocIndex].time --;
        }
        this.updateState(this);
    }

    public displayRestTime = (blocId: number) => {
        const restBlocIndex = this.blocs.findIndex(bloc => bloc.id == blocId) + 1;
        return this.blocs[restBlocIndex].time;
    }
}

export class BlocClass implements IBloc{
    public time: number; id; handleDelete; updateBloc; blocGroupId; guideline;
    constructor(props){
        this.id = props.id;
        this.time = props.bloc ? props.bloc.time : 10;
        this.handleDelete = props.handleDelete;
        this.updateBloc = props.handleUpdate;
        this.blocGroupId = props.blocGroupId;
        this.guideline  = props.bloc ? props.bloc.guideline : props.guideline
    }
    public setTime = (param) => {
        if (param == '+')
            this.time ++;
        else if (param == '-' && this.time > 0)
            this.time --;
        else if (typeof param != 'string') {
            const newValue = param.target.value;
            (isNaN(newValue)) ? this.time = this.time : this.time = Math.round(newValue);
        }
        this.updateBloc(this);
    }
}
export class TrainingBlocClass extends BlocClass implements ITrainingBloc{
    public intensity; fingers; usedHolds
    constructor(props){
        super(props);
        this.usedHolds=props.bloc ? props.bloc.usedHolds :[];
        this.intensity =props.bloc? props.bloc.intensity : 50;
        this.fingers = props.bloc ? props.bloc.fingers : [[1,1,1,1,0],[0,1,1,1,1]];
    }

    public setFingers=(handIndex, fingerIndex)=>{
        this.fingers[handIndex][fingerIndex] = this.fingers[handIndex][fingerIndex] == 0?1:0;
        this.updateBloc(this);
    }
    public setGuideline=(e, {value})=>{
        this.guideline =value;
        this.updateBloc(this);
    }
    public setUsedHolds=(usedHolds: UsedHold[])=>{
        this.usedHolds = [...usedHolds];
        this.updateBloc(this);
    }
    public setIntensity=(param: "+"|"-")=>{
        if(param == '+')
            this.intensity += 5;
        else if (param == '-' && this.intensity > 0)
            this.intensity -= 5;
        this.updateBloc(this);
    }
}

export class RestBlocClass extends BlocClass implements IRestBloc{
    constructor(props){
        super(props);
    }
}